import React from "react";
import {withRouter, Link} from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  regSuccessIcon: {
    color: "green",
    fontSize: "96px",
    align: "center"
  },
  ...customSelectStyle
};

class SubmitAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayMessage: '',
      registrationSubmitStatus: '',
      showLoginLink: false,
      displayHeader: 'Phew, thanks for sticking with us.',
      showSuccessIcon: false
    };
  }
  sendState() {
    return this.state;
  }
  isValidated() {

    return true;
  }

  updateRegistrationMessage(neweHeader, newMessage, showLoginLink, showSuccessIcon) {
    this.setState({
      displayHeader: neweHeader,
      displayMessage: newMessage,
      showLoginLink: showLoginLink,
      showSuccessIcon: showSuccessIcon
    })
  }

  componentDidMount() {
    var displayMessageCustom = ''
    switch (this.props.location.pathname) {
      case "/signupProvider":
        displayMessageCustom = "helping patients save money while getting great care"
        break
      case "/signupEmployer":
        displayMessageCustom = "saving money while providing great care for your employees"
        break
      default:
        displayMessageCustom = "great care"
        break
    }

    var displayMessage = "We know that was a lot, but you are on the way to " + displayMessageCustom + "." +
                          " Click finish and we'll set up your account."
    this.setState({
      displayMessage: displayMessage
    })
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12}>
          <h4 id="registrationCompleteMessage" className={classes.infoText}>{this.state.displayHeader}</h4>
        </GridItem>
        <GridItem xs={12} sm={7}>
          <GridContainer justifyContent="center">
            <CheckCircleOutline className={classes.regSuccessIcon}  style={this.state.showSuccessIcon ? {} : { display: 'none' }} />
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={7}>
          <p>{this.state.displayMessage}</p>
        </GridItem>
        <GridItem xs={12} sm={7}>
          <span style={this.state.showLoginLink ? {} : { display: 'none' }}>
            <h5><Link to="/login">Click here to log in.</Link></h5>
          </span>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withRouter(withStyles(style)(SubmitAgreement));
